import React, { useContext } from "react";
import NotificationControl from "./NotificationControl";
import NotificationSettingsContext from "../../contexts/NotificationsContext";
import ReactToolTip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import TenantFeatureContext from "../../contexts/TenantContext";

const NotificationsSettingsList = props => {
  const settingsContext = useContext(NotificationSettingsContext);
  const { notificationSettings, updateTypeSettings, loading } = settingsContext;
  const { tenantHasFeature } = useContext(TenantFeatureContext);
  const allowedforLeadGeneration = process.env.REACT_APP_LEAD_GEN_EMAIL_CC_LIST ? ['mmurray@sw2.net', ...process.env.REACT_APP_LEAD_GEN_EMAIL_CC_LIST.split(",").map(e => e.trim())] : ['mmurray@sw2.net']
  const freeTrialRelatedNotifications = [
    'Trial Started Notification',
    'Trial Ending Soon Notification',
    'Trial Complete Notification'
  ]
  const allowedforFreeTrialRelatedNotifications = process.env.REACT_APP_FREE_TRIAL_RELATED_EMAIL_CC_LIST ? ['mmurray@sw2.net', ...process.env.REACT_APP_FREE_TRIAL_RELATED_EMAIL_CC_LIST.split(",").map(e => e.trim())] : ['mmurray@sw2.net']

  // Role helpers
  const isSuperAdmin = props.role === 'Super Admin'
  const isAdmin = props.role === 'Admin'

  // Names to hide based on role
  const superAdminOnly = [
    'Lead Generation Notification'
  ];

  const adminAndSuperAdminOnly = [
    'Trial Started Notification',
    'Trial Ending Soon Notification',
    'Trial Complete Notification',
    'Billing Details',
    'Payment Pending Warning',
    'Account Deactivated'
  ];

  // Compute filtered list once
  const filteredSettings = notificationSettings.filter(setting => {
    // Super admin sees everything
    if (isSuperAdmin) return true;

    // Admin cannot see super-admin-only items
    if (isAdmin) {
      if (superAdminOnly.includes(setting.name)) return false;
      return true;
    }

    // Regular users: hide both super-admin-only and admin/super-admin-only
    if (superAdminOnly.includes(setting.name)) return false;
    if (adminAndSuperAdminOnly.includes(setting.name)) return false;

    return true;
  });

  return (
    <div className="notification-settings">
      <h3>Notification Settings</h3>
      <span className="sub-header-wrapper" >
        <span className="sub-header">Toggle the delivery methods for each notification type</span>
        <span
          className="help-icon"
          data-tip={'By turning on SMS/Text notifications, you are consenting to receive text message notifications from SW2. Data rates may apply. To opt-out, simply turn off the SMS notification for each notification type.'}
          data-delay-show="125"
          onMouseOver={() => ReactToolTip.show()}
        >
          <FontAwesomeIcon icon={faQuestionCircle} />
        </span>
      </span>
      {filteredSettings.map(setting => {
        if ((setting.name === 'Daily Precipitation Notification') && props.user && allowedforLeadGeneration.includes(props.user.email)) {
          return
        }

        if (freeTrialRelatedNotifications.includes(setting.name) && props.user && allowedforFreeTrialRelatedNotifications.includes(props.user.email)) {
          return
        }

        if (props.isRegulator2) {
          if (setting.name === "Inspection Complete") {
            return (
              <NotificationControl
                updateSettings={updateTypeSettings}
                id={setting.id}
                name={setting.name}
                isEnabled={setting.is_enabled}
                defaultEmailMessage={setting.default_email_message}
                hasCustomMessage={setting.has_custom_message}
                key={setting.id}
                loading={loading}
                description={setting.description}
              />
            )
          }

          return null
        }

        if (setting.name === 'Daily Precipitation Notification') {
          return (
            <NotificationControl
              updateSettings={updateTypeSettings}
              id={setting.id}
              name={setting.name}
              isEnabled={tenantHasFeature('Precipitation Notification') ? setting.is_enabled : []}
              defaultEmailMessage={setting.default_email_message}
              hasCustomMessage={setting.has_custom_message}
              key={setting.id}
              loading={tenantHasFeature('Precipitation Notification') ? loading : true}
              description={setting.description}
            />
          );
        }

        return (
          <NotificationControl
            updateSettings={updateTypeSettings}
            id={setting.id}
            name={setting.name}
            isEnabled={setting.is_enabled}
            defaultEmailMessage={setting.default_email_message}
            hasCustomMessage={setting.has_custom_message}
            key={setting.id}
            loading={loading}
            description={setting.description}
          />
        )
      })}
      {!tenantHasFeature('Precipitation Notification') && (
        <section className='container precipitation-error-msg-wrapper'>
          <p>
            “Precipitation notifications are not included in this accounts license agreement.
            To turn on please contact you company's administrator.”
          </p>
        </section>
      )}
    </div>
  );
};

export default NotificationsSettingsList;
